import { render, staticRenderFns } from "./LocalBankSummary.vue?vue&type=template&id=a01d20fe&scoped=true&"
import script from "./LocalBankSummary.vue?vue&type=script&lang=js&"
export * from "./LocalBankSummary.vue?vue&type=script&lang=js&"
import style0 from "./LocalBankSummary.vue?vue&type=style&index=0&id=a01d20fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01d20fe",
  null
  
)

export default component.exports